import { useMemo } from 'react';

import { useTranslate } from '@i18n';
import { useLiveAnalysisConfig } from '@queries';
import { Box, Text, u } from '@ui';

import { useLiveAnalysisSupportedParameters } from './useLiveAnalysisSupportedParameters';

export const LiveAnalysisActiveParameters = () => {
    const { data: config } = useLiveAnalysisConfig();

    const supportedParameters = useLiveAnalysisSupportedParameters();
    const supportedParameterMap = useMemo(
        () => Object.fromEntries(supportedParameters?.map((node) => [node.parameter.smpId, node] as const) ?? []),
        [supportedParameters],
    );
    const t = useTranslate();
    if (!config) return null;
    return (
        <Box display="flex" gap={u(2)} py={u(1)}>
            <Text variant="small">Selected:</Text>
            {config.parameters.map((parameter) => {
                return (
                    <Text key={parameter.id} variant="small" fontWeight={700}>
                        {t(supportedParameterMap[parameter.id]?.i18n ?? '-')}
                    </Text>
                );
            })}
        </Box>
    );
};
